import {
  storeReceiptMealPlan,
  getListMealPlanReceiptInfo,
  getMealPlanReceiptByVoucherCode,
  getInfoMealPlanPayment
} from '@/api/service'

const getInfoMealPlan = (context, voucherCode) => {
  getInfoMealPlanPayment(voucherCode).then((response) => {
    context.commit('MEALPLAN_INFO', response)
  })
}

const resetMealPlanInfo = (context) => {
  context.commit('RESET_MEALPLAN_INFO')
}

const saveInfoPax = (context, data) => {
  return storeReceiptMealPlan(data).then((response) => {
    return response
  })
}

const getMealPlanReceiptInfo = (context) => {
  getListMealPlanReceiptInfo().then((response) => {
    context.commit('MEAL_PLAN_RECEIPT_INFO', response)
  })
}

const getMealPlanByVoucherCode = (context, object) => {
  return getMealPlanReceiptByVoucherCode(object.voucher_code).then((response) => {
    context.commit('MEAL_PLAN_RECEIPT_INFO_BY_VOUCHER_CODE', response)
    return response
  })
}

export default {
  saveInfoPax,
  getMealPlanReceiptInfo,
  getMealPlanByVoucherCode,
  getInfoMealPlan,
  resetMealPlanInfo
}
